<template>
    <div class="container-fluid">
        <h1>{{$t(this.viewTitle)}}</h1>
        <div class="row">
            <div class="col-sm-12">
                <div class="row">
                    <div class="wos__content container-fluid bg-white shadow-sm">
                        <section class="mb-5">
                            <div class="row mt-4">
                                <div class="col-sm-12 col-md-3 border-right">
                                    <h5 class="text-center">{{$t('components.stocklist.filters')}}</h5>
                                    <hr>
                                    <button class="btn btn-sm btn-wos-real w-100" @click="clearFilters">
                                        {{$t('components.stocklist.btnClearFilters')}}
                                    </button>
                                    <div class="row mt-2">
                                        <div class="col-sm-12">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.filterProducts')}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in productFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.shopord.needweek') | capitalize}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in readinessFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            <span v-if="item.value !== 'NOW'">
                                                                {{$t('components.shopord.readyWeek', {num: item.value})}}
                                                            </span>
                                                            <span v-else>
                                                                {{$t('components.stock-mixed.available-now')}}
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{$t('components.stocklist.warehouse') | capitalize}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect onhover" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(item, index) in warehouseFilters" :key="index" class="mb-2">
                                                        <label><input type="checkbox" v-model="item.checked" :value="item.value"/>
                                                            {{item.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card mt-2" v-for="(item, index) in characteristicFilters" :key="index">
                                                <div class="card-header">
                                                    <h4 class="card-title">{{item.name}}</h4>
                                                </div>
                                                <div class="card-body text-sm noselect" style="max-height: 350px; overflow-y: scroll">
                                                    <div v-for="(characteristic, index2) in item.values" :key="index2" class="mb-2">
                                                        <label><input type="checkbox" v-model="characteristic.checked" :value="characteristic.option_value_id"/>
                                                            {{characteristic.name}}</label>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <button class="btn btn-sm btn-wos-real w-100" @click="applyFilters">
                                                        {{$t('components.stocklist.btnApplyFilters')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-9">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4 text-wellis-gold">
                                            {{$t('components.stocklist.dataLength', {len: dataLength, time: fetchTimeComputed})}}
                                        </div>
                                        <div class="col-sm-12 offset-md-4 col-md-4">
                                            <input class="form-control form-control-sm mb-2" type="text" :placeholder="$t('components.topbar.search')" v-model="quickSearch"/>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="row">
                                                <div class="col-sm-12 p-0 d-flex col-lg-3" v-for="item in filteredResults"
                                                     :key="item.name+'_'+(Object.values(item.stocklist).length+item.shopord.length)">
                                                    <StockMixedProductCard :stockItem="item"
                                                                           :btn-configurator="$store.getters['configStore/getShopOrdModuleStatus']"
                                                                           :btn-add-cart="$store.getters['configStore/getMixedStockModuleStatus']"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {__clone, empty} from "@/helpers";
import StockMixedApiService from "@/api/stock-mixed.api";
import {EVENT_LANG_CHANGE} from "@/core/constants";
import StockMixedProductCard from "@/components/application/StockMixedProductCard";
import ExplorerHistory from "@/modules/explorer";

export default {
    name: "StockMixed",
    components: {StockMixedProductCard},
    mounted() {
        ExplorerHistory.resolve(this).then(result => {
            if (!result) {
                if (this.$route.query.product) {
                    let products = JSON.parse(this.$route.query.product);
                    if (products instanceof Array && products.length > 0) {
                        this.queryFiltering = true;
                        this.$set(this.queryFilters, 'product', products);
                    }
                }

                if (this.$route.query.characteristics) {
                    let characteristics = JSON.parse(this.$route.query.characteristics);
                    if (characteristics instanceof Object) {
                        this.queryFiltering = true;
                        this.$set(this.queryFilters, 'characteristics', characteristics);
                    }
                }
                this.bootstrap().then(() => {
                    setTimeout(() => ExplorerHistory.saveCurrentState(this, this.$route, window.pageYOffset, this.viewTitle, true), 100);
                });
            }
        });

        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.bootstrap();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    beforeRouteLeave(to, from, next) {
        let loader = this.$loading.show();
        ExplorerHistory.saveCurrentState(this, from, window.pageYOffset, this.viewTitle, true).then(() => {
            loader.hide();
            next();
        });
    },

    data() {
        return {
            viewTitle: 'components.stock-mixed.title',
            stock: [],
            quickSearch: null,
            filters: {
                category: [],
                product: [],
                warehouse: [],
                readiness: [],
                characteristics: []
            },
            fetchTime: 0,
            queryFiltering: false,
            queryFilters: {
                category: [],
                product: [],
                warehouse: [],
                readiness: [],
                characteristics: []
            }
        }
    },

    methods: {
        bootstrap(filters = null) {
            return new Promise((resolve) => {
                let loader = this.$loading.show();
                let fetchStartTime = Date.now();
                StockMixedApiService.getStock(filters)
                    .then(response => {
                        this.$set(this, 'stock', Object.values(response.data.stock));
                        if (filters === null) {
                            this.filters.product = response.data.filters.product;
                            this.filters.warehouse = response.data.filters.warehouse;
                            this.filters.readiness = [{
                                value: "NOW",
                                name: "now",
                                checked: false
                            }, ...response.data.filters.readiness];
                            this.filters.characteristics = Object.values(response.data.filters.characteristics);
                        }
                        if (this.hasQueryFilter) {
                            let filters = __clone(this.queryFilters);
                            this.queryFilters = {
                                category: [],
                                product: [],
                                warehouse: [],
                                readiness: [],
                                characteristics: []
                            };
                            this.queryFiltering = false;
                            this.toggleFilters(filters);
                            this.applyFilters();
                        } else {
                            this.$scrollTop();
                        }
                        this.fetchTime = Date.now() - fetchStartTime;
                        resolve();
                    })
                    .catch(() => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('components.stocklist.notready')
                        });
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    })
            });
        },

        clearFilters() {
            this.filters.product.map(item => item.checked = false);
            this.filters.characteristics.map(item => item.values.map(char => char.checked = false));
            this.bootstrap();
        },

        applyFilters() {
            let filters = {
                product: [],
                characteristics: {},
                readiness: [],
                warehouse: [],
            };
            this.filters.product.map(item => {
                if (item.checked) {
                    filters.product.push(item.value);
                }
            });

            this.filters.warehouse.map(item => {
                if (item.checked) {
                    filters.warehouse.push(item.value);
                }
            });

            this.filters.readiness.map(item => {
                if (item.checked) {
                    filters.readiness.push(item.value);
                }
            });

            this.filters.characteristics.map(char => {
                char.values.map(item => {
                    if (item.checked) {
                        if (typeof filters.characteristics[char.characteristic_id] === 'undefined') {
                            filters.characteristics[char.characteristic_id] = [];
                        }
                        filters.characteristics[char.characteristic_id].push(item.option_value_id);
                    }
                })
            });

            this.bootstrap(filters);
        },

        toggleFilters(filters) {
            filters.product.map(x => {
                let product = this.filters.product.find(item => item.value === x);
                if (product) {
                    product.checked = true;
                }
            });

            for (const [key, value] of Object.entries(filters.characteristics)) {
                let char = this.filters.characteristics.find(item => item.characteristic_id === key);
                if (char) {
                    value.forEach(val => {
                        let opt = char.values.find(item => item.option_value_id === val);
                        if (opt) {
                            opt.checked = true;
                        }
                    });
                }
            }

        },

        removeItem(container, identifier) {
            this.stock.forEach((item, index) => {
                if (container === 'shopord') {
                    let shopOrdItemIndex = item.shopord.findIndex(x => x.uniqueId === identifier);
                    if (shopOrdItemIndex !== -1) {
                        this.stock[index].shopord[shopOrdItemIndex].hidden = true;
                    }
                }
            });
        }
    },

    computed: {
        Stock() {
            return this.stock;
        },

        filteredResults() {
            let items = [];
            this.Stock.forEach(item => {
                if (!empty(this.quickSearch)) {
                    let r = new RegExp(this.quickSearch, "iu");
                    if (r.test(item.name) || r.test(item.catalogNo)) {
                        items.push(item);
                    }
                } else {
                    items.push(item);
                }
            });

            items.sort((a, b) => a.name > b.name);

            return items;
        },

        productFilters() {
            return this.filters.product;
        },

        warehouseFilters() {
            return this.filters.warehouse;
        },

        characteristicFilters() {
            return this.filters.characteristics;
        },

        readinessFilters() {
            return this.filters.readiness;
        },

        dataLength() {
            let len = 0;
            this.stock.forEach(item => {
                len += item.shopord.length;
                Object.values(item.stocklist).forEach(config => len += config.quantity);
            });
            return len;
        },

        fetchTimeComputed() {
            return (Math.abs(this.fetchTime) / 1000).toFixed(2);
        },

        hasQueryFilter() {
            return this.queryFiltering;
        }
    }
}
</script>

<style scoped>
.text-sm {
    font-size: 13px;
}

input[type="checkbox"] {
    opacity: 1;
}
</style>
